
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire25bc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire25bc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $800sp = parcelRequire("800sp");

var $4OBpG = parcelRequire("4OBpG");
"use strict";
var $b15150b647d29371$var$_dec, $b15150b647d29371$var$_dec2, $b15150b647d29371$var$_class, $b15150b647d29371$var$_class2, $b15150b647d29371$var$_descriptor;
function $b15150b647d29371$var$_initializerDefineProperty(e, i, r, l) {
    r && Object.defineProperty(e, i, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(l) : void 0
    });
}
function $b15150b647d29371$var$_applyDecoratedDescriptor(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
function $b15150b647d29371$var$_initializerWarningHelper(r, e) {
    throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
let $b15150b647d29371$export$9f7601a929cb332c = ($b15150b647d29371$var$_dec = (0, $4OBpG.customElement)("simple-greeting"), $b15150b647d29371$var$_dec2 = (0, $4OBpG.property)(), $b15150b647d29371$var$_dec($b15150b647d29371$var$_class = ($b15150b647d29371$var$_class2 = class SimpleGreeting extends (0, $800sp.LitElement) {
    constructor(...args){
        super(...args);
        this.styles = (0, $800sp.css)`p { 
        color: pink;
        background-color: red;
    }`;
        $b15150b647d29371$var$_initializerDefineProperty(this, "name", $b15150b647d29371$var$_descriptor, this);
    }
    render() {
        return (0, $800sp.html)`<p>Hello, ${this.name}!</p>`;
    }
}, $b15150b647d29371$var$_descriptor = $b15150b647d29371$var$_applyDecoratedDescriptor($b15150b647d29371$var$_class2.prototype, "name", [
    $b15150b647d29371$var$_dec2
], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function() {
        return "World";
    }
}), $b15150b647d29371$var$_class2)) || $b15150b647d29371$var$_class);


//# sourceMappingURL=index.94e89908.js.map
